import { ControlledTextField } from 'components/Form';
import { ModalDialog } from 'components/ModalDialog';
import type { CostGroupEnum } from 'gql/graphql';
import { Button, IconEdit } from 'uikit';
import { formatDateToLocale } from 'utils';

import { useCallback, useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';

import { commentRules } from '../helpers';
import { useUpdateActPriceComment } from '../hooks/useUpdateActPriceComment';

interface IActKc2CommentEditModal {
    comment: string;
    actNumber: number | undefined;
    actDate: string | undefined;
    actCostGroup: CostGroupEnum;
    actId: number;
    priceId: number;
    onSuccess: (reloadRowsIds: number[]) => void;
    disabled?: boolean;
}

export const ActKc2CommentEditModal = (props: IActKc2CommentEditModal) => {
    const { actNumber, actDate, comment, actCostGroup, actId, priceId, onSuccess, disabled } = props;

    const [isOpened, setIsOpened] = useState(false);

    const { control, handleSubmit, setValue } = useForm<{
        comment: string | null | undefined;
    }>();

    useEffect(() => {
        if (isOpened) {
            setValue('comment', comment);
        }
    }, [comment, isOpened, setValue]);

    const handleBtnClick = useCallback(() => {
        setIsOpened((prev) => !prev);
    }, []);

    const modalTitle = useMemo(() => {
        const actNumString = actNumber ? `№${actNumber}` : '';
        const actDateString = actDate ? `от ${formatDateToLocale(actDate)}` : '';

        return `Акт ${actNumString} ${actDateString}`;
    }, [actDate, actNumber]);

    const { submitHandler, isCommit } = useUpdateActPriceComment({
        actId,
        actCostGroup,
        priceId,
        onSuccess,
        onCloseModal: handleBtnClick,
    });

    return (
        <>
            <Button view="clear" iconLeft={IconEdit} size="s" onlyIcon onClick={handleBtnClick} disabled={disabled} />

            <ModalDialog
                title={modalTitle}
                isOpen={isOpened}
                hasOverlay
                withTitleCloseButton
                bodyWidth={600}
                isCommit={isCommit}
                onClose={handleBtnClick}
                onConfirm={handleSubmit(submitHandler)}
                btnConfirmLabel="Сохранить"
                btnCancelLabel="Отменить"
            >
                <div
                    style={{
                        padding: '24px',
                    }}
                >
                    <ControlledTextField
                        control={control}
                        name="comment"
                        label="Комментарий"
                        labelPosition="top"
                        placeholder=""
                        type="textarea"
                        rows={6}
                        rules={commentRules}
                    />
                </div>
            </ModalDialog>
        </>
    );
};

ActKc2CommentEditModal.displayName = 'ActKc2CommentEditModal';
